<template>
  <div class="simple-scroll-list" ref="scrollList" @scroll="scroll">
    <div class="list-inner">
      <slot></slot>
    </div>
    <div class="remark" v-show="showRemark">
      <van-loading v-show="!finished && loadingText" size="24px">{{
        loadingText
      }}</van-loading>
      <span v-show="finished">{{ finishedText }}</span>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  model: {
    prop: "value",
    event: "changeLoading",
  },
  props: {
    value: {
      type: Boolean,
    },
    finished: {
      type: Boolean,
    },
    finishedText: {
      type: String,
      default: "没有更多了",
    },
    loadingText: {
      type: String,
      default: "加载中 ...",
    },
	closeLoad:{
		type:String,
		
	},
  },
  beforeRouteLeave(to, from, next) {console.log(document.documentElement.scrollTop,document.body.scrollTop,window.pageYOffset,555)
  	  this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
  	   // 设置下一个路由的 meta
  	   console.log(this.scrollTop,666)
  	  to.meta.keepAlive = false;  // 让 A 缓存，即不刷新
  	  next();
  },
  data() {
    return {};
  },
  methods: {
    load() {console.log(1,this.value,this.finished)
      if (!this.value && !this.finished) {
        this.$emit("changeLoading", true);
        this.$emit("load");
      }
    },
    scroll() {
      if (!this.value && !this.finished) {
        let scrollBottom =
          this.$refs.scrollList.scrollHeight -
          this.$refs.scrollList.clientHeight -
          this.$refs.scrollList.scrollTop;
        if (scrollBottom <= 5) {
          this.load();
        }
      }
    },
    getScrollTop() {
      let scrollTop = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollTop = document.body.scrollTop;
      }
      return scrollTop;
    },
	// 加载更多
	onSroll(){
		let that = this
		window.onscroll = function(){
		//变量scrollTop是滚动条滚动时，距离顶部的距离
		var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
		//变量windowHeight是可视区的高度
		var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
		//变量scrollHeight是滚动条的总高度
		var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
		   //滚动条到底部的条件
		   if(scrollTop+windowHeight==scrollHeight){
			   console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
		   //写后台加载数据的函数
		   that.load()
		  
		   } 
		}
	},
	// 注销加载更多
	closeLoad(){
		window.removeEventListener('scroll', this.onSroll, false);
	},
	// destroyed(){
	// 	window.removeEventListener('scroll', this.onSroll, false);
	// },
  },
  components: {},
  created() {
    this.load();
	// window.addEventListener('scroll', this.onSroll)
	
  },
  
  watch: {
    async value(val) {
      if (!val && !this.finished) {
        this.$sleep(100).then(() => {
          if (
            this.$refs.scrollList.scrollHeight ===
            this.$refs.scrollList.clientHeight
          ) {
            this.scroll();
          }
        });
      }
    },
	closeLoad(){console.log(2)
		this.closeLoad()
	}
  },
  computed: {
    showRemark() {
      return (
        (this.value && this.loadingText) || (this.finished && this.finishedText)
      );
    },
  },
};
</script>

<style scoped lang="less">
.simple-scroll-list {
  height: 100%;
  // overflow: auto;
  color: #cccccc;

  .remark {
    text-align: center;
    padding: 10px;
    font-size: 14px;
  }
}
</style>